<template>
  <div
    class="float-modal"
    :style="userStyle"
    @touchstart="touchstartFn"
    @touchmove="touchmoveFn"
    @touchend="touchendFn"
  >
    <div class="active-desc" @click="toHomeMy">面试</div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "wy-float",
  computed: {
    ...mapState({
      viewport: state => state.viewport
    })
  },
  data() {
    return {
      userStyle: "",
      distance: 80
    };
  },
  methods: {
    toHomeMy() {
      this.$router.push("/sub/my_jobfair");
    },
    // 拖动浮窗
    touchstartFn() {},
    touchmoveFn(e) {
      let that = this;

      const { viewport, distance } = that;

      const { changedTouches } = e;
      const touch = changedTouches[0];

      // pageX, pageY
      let { clientY } = touch || {};

      e.preventDefault();
      if (clientY && viewport && clientY < viewport.height-distance && clientY > distance){
          that.userStyle = "top:" + clientY + "px;";
      }
    },
    touchendFn() {}
  }
};
</script>

<style lang="scss" scoped>
.float-modal {
  position: fixed;
  top: 60%;
  right: 0.15rem;
  z-index: 12;

  .active-desc {
    font-size: 0.14rem;
    line-height: 0.2rem;
    padding: 0.1rem 0;
    color: #fff;
    background-color: #439bff;
    width: 0.5rem;
    height: 0.5rem;
    text-align: center;
    border: 0.05rem solid #fff;
    @include border-radius(50%);
    @include box-sizing(border-box);
  }
}
</style>
